import React, { useEffect } from "react";

import { notification } from "antd";

const showNotifications = (robots = []) => {
  robots.map((robot) => {
    if (robot.space) {
      const usedSpace = robot.space
        ? (parseInt(robot.space.used, 10) / parseInt(robot.space.total, 10)) *
          100
        : null;
      if (usedSpace > 75)
        notification.warning({
          message: `${robot.name} has ${robot.space.free} disk space left`,
          description: "Please contact customer to free up the space.",

          onClick: () => {
            console.log("Notification Closed!");
          },
        });
    }
  });
};

function Notifications(props) {
  const { robots = [] } = props;
  useEffect(() => {
    // showNotifications(robots);
  }, [robots]);

  return <React.Fragment />;
}

export default Notifications;
